// @flow

import { setProps, getProps } from '../props';
import { clearOrder } from '../State/order';
import { setFetching } from '../State/fetching';
import fetchOrder from '../Services/fetchOrder';

export default (props: any) => (dispatch: Function) => {
  const oldProps = getProps();
  setProps(props);
  
  // Check if the order ID has changed
  const oldOrderId = oldProps && oldProps.match && oldProps.match.params && oldProps.match.params.id;
  const newOrderId = props && props.match && props.match.params && props.match.params.id;
  
  if (oldOrderId && newOrderId && oldOrderId !== newOrderId) {
    // Clear the old order data and show loading state
    dispatch(clearOrder());
    dispatch(setFetching(true));
    
    // Fetch the new order
    dispatch(fetchOrder());
  }
};